<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import SelecteurTypeOccurrence from '@/components/generiques/SelecteurTypeOccurrence.vue';

const { idErreur, desactive } = defineProps({
    idErreur: String,
    desactive: Boolean
});

const valeur = defineModel('valeur', {
    type: String
});

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(typeOccurrence) {
    valeur.value = typeOccurrence;
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <SelecteurTypeOccurrence 
            v-model:typeOccurrence="valeur"
            :desactive="desactive"
            @update:typeOccurrence="modifierValeur" />
    </Saisie>
</template>

<style scoped>

</style>